import { FC } from 'react'
import styles from './PageDescription.pcss'

const PageDescription: FC<{ children: React.ReactNode }> = ({ children }) => {
	return <div className={styles.description}>{children}</div>
}

export default PageDescription
